const esc = (s) => {
	const str = String(s ?? '')
	return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str
}
export const exportCsv = (data, filename) => {
	if (!data.length) return
	const csv = data.map((r) => r.map(esc).join(',')).join('\n')
	const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
	const url = URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = url
	a.download = `${filename}.csv`
	a.click()
	URL.revokeObjectURL(url)
}

export const truncateText = (str, n = 20) =>
	str?.slice(0, n) + (str?.length > n ? '...' : '') || '--'
